import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as MenuIcon } from 'src/assets/images/ic_tricolon.svg';
import { throttle } from 'src/lib/utils';
import { CloseButton } from '../buttons/CloseButton';
import { Modal } from '../Modal';

interface DialogProps {
  hasHeader?: boolean;
  hasMenu?: boolean;
  menuAriaLabel?: string;
  title?: string;
  titleColor?: string;
  onMenuClick?: () => void;
  contentOverflow?: 'visible' | 'hidden' | 'auto'; // overflow property of css
}

export const Dialog: React.FC<DialogProps> = ({
  hasHeader,
  hasMenu,
  menuAriaLabel,
  title,
  titleColor,
  onMenuClick,
  contentOverflow,
  children
}) => {
  const history = useHistory();
  const handleCloseClick = useCallback(
    throttle(() => {
      history.goBack();
    }, 1000),
    [history]
  );
  return (
    <Modal>
      <div
        className={css`
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: 480px;
          min-height: 240px;
          overflow-wrap: break-word;
          position: relative;
          padding-top: ${hasHeader ? '0' : '24px'};

          header {
            flex: 0 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 20px 0;
          }
          .menu {
            width: 44px;
            height: 44px;
            padding: 6px;
            border-radius: 50%;
            transition: background-color 0.12s;
            :active {
              background-color: #ece5d4;
            }
          }
          .title {
            font-size: 20px;
            color: ${titleColor || '#4d3906'};
            padding: 0 24px;
            margin: 0 auto;
            text-align: center;
            overflow-wrap: break-word;
          }
          .content {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            overflow: ${contentOverflow || 'auto'};
            font-size: 16px;
            color: #938666;
            margin: 4px 4px 20px;
            padding: 0 16px 0;
          }
        `}
      >
        {hasHeader && (
          <header>
            <CloseButton onClick={handleCloseClick} />
            {hasMenu && (
              <button className="menu" onClick={onMenuClick} aria-label={menuAriaLabel}>
                <MenuIcon />
              </button>
            )}
          </header>
        )}
        {title && <h1 className="title">{title}</h1>}
        <div className="content">{children}</div>
      </div>
    </Modal>
  );
};
